export const CLASSNAME_PREFIX = 'Select'

export const SELECT_INPUT_ACTIONS = {
  INPUT_CHANGE: 'input-change',
  SET_VALUE: 'set-value',
  MENU_CLOSE: 'menu-close',
  INPUT_BLUR: 'input-blur',
}

export const CLEAR_INPUT_ACTIONS = [
  SELECT_INPUT_ACTIONS.MENU_CLOSE,
  SELECT_INPUT_ACTIONS.INPUT_BLUR,
]

export const IS_APPLE_DEVICE =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent)
